import { connect } from 'react-redux';
import { InsiderTradingTransactions } from '@/pages/CompanyReport/components/InsiderTradingTransactions';
import { makeInsiderTradingTransactions } from '@/pages/CompanyReport/components/InsiderTradingTransactions/redux/selectors';
import { getSummary } from '@/pages/CompanyReport/redux/selectors';
const makeMapStateToProps = () => {
  const insiderTradingTransactionsSelector = makeInsiderTradingTransactions();
  return (state, props) => {
    const summary = getSummary(state, props);
    return {
      data: insiderTradingTransactionsSelector(state, props),
      uniqueSymbol: summary.uniqueSymbol,
    };
  };
};

export default connect(makeMapStateToProps)(InsiderTradingTransactions);
